/**
 * 获取文件名后缀, 包含小数点, 如 .png
 * - api 接口内部调用
 * @param {string} filename 文件名
 */
export default (filename) => {
	const i = filename.lastIndexOf('.')
	if (i === -1) return ''
	return filename.substring(i)
}